import { tacticalCategoryPageRecords } from "./consts";
export var isTacticalCategoryPage = function isTacticalCategoryPage(pathname) {
  return Object.values(tacticalCategoryPageRecords).some(function (_ref) {
    var pathPattern = _ref.pathPattern;
    return pathPattern.test(pathname);
  });
};
export * from "./consts";